import { render, staticRenderFns } from "./UniqueUsernameDialog.vue?vue&type=template&id=51d7cb47"
import script from "./UniqueUsernameDialog.vue?vue&type=script&lang=ts"
export * from "./UniqueUsernameDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports